//---Modal-----------------------------:
//Update the modal data
export const setModal = (data) => {
  return { type: "SET_MODAL", payload: data };
};
